// Dependencies
import React, { Component } from 'react';

class ImageText extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-6 align-self-center">
                    <img className="img-fluid pr-4" style={{height: this.props['imageHeight'] ? this.props['imageHeight'] : ''}} src={this.props.image} alt={this.props.title}/>
                </div>
                <div className="col-lg-6 align-self-center">
                { this.props.title ? 
                    <div className="mb-2">
                        <h2 className="h3 text-uppercase mb-2 g-font-weight-700" style={{color: this.props['color'] ? this.props['color'] : ''}}>{this.props.title}</h2>
                        <div className="d-inline-block g-width-35 g-height-2 g-bg-primary mb-2"></div>
                    </div>
                : null }
                    <div>
                        { this.props.description ?
                            <p style={{color: this.props['color'] ? this.props['color'] : ''}}>{this.props.description}</p>
                        : null }
                        {this.props.children}
                    </div>
                    {this.props.brand ? 
                        <div>
                            <img className="g-width-140" src={this.props.brand} alt="Brand"></img> 
                        </div>
                    : null}
                </div>
            </div>
        );
    }
}

export default ImageText;


// WEBPACK FOOTER //
// ./src/subcomponents/ImageText.js